import { css, styled } from '@mui/system';
import PitchHorizontalSVG from '@/assets/football-pitch.svg?react';

export const PitchSVG = styled(PitchHorizontalSVG)(
  () => css`
    flex: 1;
  `,
);
